//People list for school admin and district admin
import {renderEl, updatePeopleType, getSelectizeOptions} from "../../lib/common/peopleList";

const PEOPLE_TYPE_TEACHERS_STAFFS = 0;
const PEOPLE_TYPE_ADMINS_OBSERVERS = 1;

const $dataSource = $('#peopleDataSource');
const selectedRole = $dataSource.data('selected-role') || 0;
const rolesOptions = $dataSource.data('teachers-observers-roles-options') || [];

const peoplePageIds = [
    'userStatus',
    'schoolId'
];

const $roles = $('#roles');
const $peopleType = $('#peopleType');

const searchParams = new URLSearchParams(window.location.search);
const peopleType = searchParams.get('people_type');

$roles.selectize();

$peopleType.selectize({
    valueField: 'value',
    labelField: 'label',
    searchField: 'label',
    options: [],
    onChange: function (value) {
        updatePeopleType($roles, rolesOptions, value)
    }
})

peoplePageIds.forEach(id => {
    $('#' + id).selectize();
});

if (peopleType == PEOPLE_TYPE_ADMINS_OBSERVERS) {
    renderEl($roles, getSelectizeOptions(rolesOptions[PEOPLE_TYPE_ADMINS_OBSERVERS]), selectedRole);
} else {
    renderEl($roles, getSelectizeOptions(rolesOptions[PEOPLE_TYPE_TEACHERS_STAFFS]), selectedRole);
}
